<nav
  class="account-settings-nav card"
  [class.account-settings-nav--full]="fullWidth"
>
  <div class="card-body">
    @for (item of items; track item.route) {
      <a
        class="account-settings-nav__link"
        [class.account-settings-nav__link--danger]="item.danger"
        [routerLink]="item.route"
        routerLinkActive="is-active"
        [routerLinkActiveOptions]="{ exact: true }"
      >
        {{ item.label }}
      </a>
    }
  </div>
</nav>
